<template>
  <div>
    <span class="selectTitle">{{selectTitle}}</span>
    <el-select v-model="value" placeholder="请选择" size="small" :style="{width: selectWidth}">
      <el-option
        v-for="item in selectData"
        :key="item.key"
        :label="item.label"
        :value="item.key">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'input-select',
  props: {
    selectTitle: String,
    selectData: Array,
    selectKey: String,
    selectValue: {
      type: String,
      default: ''
    },
    selectWidth: {
      type: String,
      default: '160px'
    }
  },
  data () {
    return {
      value: ''
    }
  },
  created() {
    this.value = this.selectValue || ''
  },
  watch: {
    value (val) {
      this.$emit('search', {key: this.selectKey, value: val})
    },
    selectValue () {
      this.value = this.selectValue || ''
    }
  }
}
</script>

<style scoped>
.selectTitle {
  display: inline-block;
  color: #48576a;
  font-size: 14px;
  line-height: 30px;
  margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputSelect.vue